var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-card',{staticClass:"d-flex flex-column justify-center rounded-lg secondary",attrs:{"height":"100%","max-height":"350px","min-height":"200px"},on:{"click":_vm.handelAddVehicle}},[_c('v-icon',{attrs:{"size":"70","color":"white"}},[_vm._v("mdi-plus")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }